import { useAppConfiguration } from '#app/hooks/useAppConfiguration.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { Elements } from '@stripe/react-stripe-js';
import { type Stripe } from '@stripe/stripe-js';
import { loadStripe } from '@stripe/stripe-js/pure';
import { type ReactNode, useEffect, useState } from 'react';

export const StripeElements = ({
  children,
}: {
  readonly children: ReactNode;
}) => {
  const { stripeProductionApiKey, stripeSandboxApiKey } = useAppConfiguration();
  const currentUser = useCurrentUser();

  const [stripeObject, setStripeObject] =
    useState<null | Promise<null | Stripe>>(null);

  const STRIPE_PUB_KEY = currentUser?.isTestAccount
    ? stripeSandboxApiKey
    : stripeProductionApiKey;

  useEffect(() => {
    setStripeObject(loadStripe(STRIPE_PUB_KEY));
  }, [STRIPE_PUB_KEY]);

  return <Elements stripe={stripeObject}>{children}</Elements>;
};
